import React, { useState, Component } from "react";
import $ from "jquery";
import axios from "axios";

class Eqsl extends Component {
  constructor(props) {
    super(props);
    
    const visibles = [
      { name: "ses_name", label: "Kegiatan" },
      { name: "band", label: "Band" },
      { name: "mode", label: "Mode" },
      { name: "time", label: "Time (UTC)" },
      { name: "eqsl_link", label: "Link Download" },
    ];

    this.state = {
      dataEqsl: [],
      visibles: visibles
    };
  }

  fetchEqslData = (callsign, sesname) => {
    axios
      .get("https://amatir.id/ses/api-by-name.php", {
        params: {
          keyword: callsign,
          sesname: sesname
        },
      })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ dataEqsl: response.data });
        } else {
          alert(response.statusText);
          console.log(response.statusText);
        }
      })
      .catch((error) => {});
  };

  search = (sesname) => {
    const callsign = $("#callsign").val();

    this.fetchEqslData(callsign, sesname);
  };

  getEqsl = (link) => {
    window.location.replace("https://amatir.id/ses/" + link);
  };

  render() {
    const sesname = "PEKAN BUDAYA BOROBUDUR"
    
    return (
      <div className="row justify-content-center">
         <div className="row justify-content-center mb-3">
            <a className="text-center" href="https://amatir.id/" target="__blank">
              <img src="https://amatir.id/imgs/logo.png" alt="" srcset="" style={{width: 120 + 'px'}}></img>
            </a>
          </div>
        <div className="col-12 col-md-12 card mt-4">
          <div className="card-header text-center">
            <h4>DOWNLOAD EQSL CARD 8A2567WSK</h4>
          </div>
          <div className="card-body" style={{ marginTop: 20 + "px" }}>
            <div
              className="row justify-content-center"
              style={{ marginBottom: 60 + "px" }}
            >
              <div className="col-10 col-md-4">
                <div className="input-group md-form form-sm form-2 pl-0">
                  <input
                    className="form-control my-0 py-1 lime-border"
                    onKeyUp={this.search}
                    type="text"
                    placeholder="Callsign"
                    aria-label="Search"
                    id="callsign"
                    style={{ textTransform: "uppercase" }}
                  />
                  <div className="input-group-append">
                    <button
                      id="search-button"
                      className="btn btn-primary"
                      onClick={() => this.search(sesname)}
                      style={{ backgroundColor: "#ff7a57", border: "none" }}
                    >
                      CARI
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center" style={{ marginBottom: 20 + "px" }}>
              <h5>Jika tidak terlihat tombol download silakan digeser.</h5>
            </div>
            <div className="row justify-content-center">
              <div className="col-12" style={{ overflowX: "scroll" }}>
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      {this.state.visibles.map((visible) => {
                        return (
                          <th
                            scope="col"
                            className="text-center"
                            key={visible.name}
                          >
                            {visible.label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.dataEqsl.length === 0 ? (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center"
                          style={{ fontSize: 19 + "px" }}
                        >
                          Data kosong atau belum melakukan pencarian.
                        </td>
                      </tr>
                    ) : (
                      this.state.dataEqsl.map((datum, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            {this.state.visibles.map((visible) => {
                              if (visible.name === "eqsl_link") {
                                return (
                                  <td key={visible.name}>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() =>
                                        this.getEqsl(datum[visible.name], sesname)
                                      }
                                      role="button"
                                      style={{
                                        backgroundColor: "#ff7a57",
                                        borderColor: "#ff7a57",
                                        color: "white",
                                      }}
                                    >
                                      Download
                                    </button>
                                  </td>
                                );
                              }
                              return (
                                <td
                                  className="text-center"
                                  key={visible.name}
                                  style={{ fontSize: 19 + "px" }}
                                >
                                  {datum[visible.name]}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Eqsl;
